import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import './SearchResults.css';
import { API } from '../services/apiConfig';

function SearchResults({ onProductClick }) {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const debounceRef = useRef(null);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleChange = (e) => {
    const val = e.target.value;
    setQuery(val);
    clearTimeout(debounceRef.current);
    if (!val.trim()) { setResults([]); setOpen(false); return; }
    debounceRef.current = setTimeout(async () => {
      setLoading(true);
      try {
        const res = await axios.get(`${API}/api/products/search?query=${encodeURIComponent(val)}&size=6`);
        setResults(res.data.content || []);
        setOpen(true);
      } catch { setResults([]); }
      finally { setLoading(false); }
    }, 350);
  };

  const handleSelect = (product) => {
    setOpen(false);
    setQuery('');
    onProductClick(product);
  };

  const catColor = (cat) =>
    cat === 'SUPER_PREMIUM' ? '#9A1111' : cat === 'PREMIUM' ? '#0A683C' : '#107FDF';

  return (
    <div className="sr-wrapper" ref={wrapperRef}>
      <i className="fas fa-search sr-icon" />
      <input
        className="sr-input"
        type="text"
        placeholder="Search for products..."
        value={query}
        onChange={handleChange}
        onFocus={() => results.length > 0 && setOpen(true)}
      />
      {open && (
        <div className="sr-dropdown">
          {loading && <div className="sr-status">Searching...</div>}
          {!loading && results.length === 0 && <div className="sr-status">No products found</div>}
          {!loading && results.map(p => (
            <div key={p.id} className="sr-item" onClick={() => handleSelect(p)}>
              {p.mainImage
                ? <img src={`${API}${p.mainImage}`} alt={p.name} className="sr-thumb" />
                : <div className="sr-thumb sr-thumb-placeholder" />}
              <div className="sr-info">
                <span className="sr-name">{p.name}</span>
                <span className="sr-price" style={{ color: catColor(p.category) }}>₹{p.price?.toLocaleString('en-IN')}</span>
              </div>
              <span className="sr-cat" style={{ background: catColor(p.category) }}>
                {p.category?.replace('_', ' ')}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default SearchResults;
